module.exports = __webpack_public_path__ + "media/images/front/programs/icon-book-inactive-80106e8a86ec54f47953cd82ae5a699c.svg";